import PaymentDetailsContainer from "../../../../Components/Applications/ECommerce/PaymentDetails/PaymentDetailsContainer";

const PaymentDetails = () => {
  return <PaymentDetailsContainer />;
};

export default PaymentDetails;
